import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DocumentsType } from '../../models/_enum-collections';
import { AddEngagementType } from '../../models/add-engagement-type.model';
import { AdditionalDocHyperLink } from '../../models/additional-doc-hyper-link.model';
import { ApiResponse } from '../../models/api-response.model';
import { Confidence } from '../../models/confidence.model';
import { CustomerAcknowledgement } from '../../models/customer-ack.model';
import { CustomerModel } from '../../models/customer.model';
import { DeclineReason } from '../../models/decline-reason.model';
import {
  DocumentReviewModel,
  DocumentDetailsModel
} from '../../models/document-review.model';
import { EngagementDetails } from '../../models/engagement-details.model';
import { EngagementExtensionDetails } from '../../models/engagement-extension-details.model';
import { EngagementSurvey } from '../../models/engagement-survey.model';
import { EngagementTypeDropdown } from '../../models/engagement-type-dropdown.model';
import { EngagementType } from '../../models/engagement-type.model';
import { IncentiveDetails } from '../../models/incentive-details.model';
import { InvoiceRejectReason } from '../../models/invoice-reject-reason';
import { L1InternalStatus } from '../../models/l1-internal-status.model';
import { L2InternalStatus } from '../../models/l2-internal-status.model';
import { MilestonePaymentStatus } from '../../models/milestone-payment-status.model';
import { Milestone2Designation } from '../../models/milestone2-designation.model';
import { Milestone2PaymentStatus } from '../../models/milestone2-payment-status.model';
import { MonthList } from '../../models/month-list.model';
import { MsaipMilestonePayment } from '../../models/msai-m2-payment-details.model';
import { MsaipAction } from '../../models/msaip-action.model';
import { MsaipExceptionDisputeStatus } from '../../models/msaip-exception-dispute-status.model';
import { MsaipRequestReason } from '../../models/msaip-request-reason.model';
import { NominationPOESurvey } from '../../models/nomination-poe-survey.model';
import { NotesModel } from '../../models/notes.model';
import { ODimIncentive } from '../../models/o-dim-incentive.model';
import { PartnerType } from '../../models/partner-type.model';
import { PartnerModel } from '../../models/partner.model';
import { PmoInternalModel } from '../../models/pmo-internal.model';
import { PmoNextStatus } from '../../models/pmo-next-status.model';
import { PmoStatus } from '../../models/pmo-status.model';
import { PoeDocHyperLink } from '../../models/poe-doc-hyper-link.model';
import { PoeDocStatus } from '../../models/poe-doc-status.model';
import {
  PoeDocument,
  SpecialInvestmentPoeDocument
} from '../../models/poe-document.model';
import {
  PoeInformationSurvey,
  UpdatePOEInformationRequest,
  UpdateAdvisorIncentivesPOEInformationRequest
} from '../../models/poe-information-survey.model';
import { PoeInformation } from '../../models/poe-information.model';
import { PoeinvoiceStatus } from '../../models/poe-invoice-status.model';
import { PoeNominationDocuments } from '../../models/poe-nomination-documents.model';
import { PoeStatus } from '../../models/poe-status.model';
import { PoeSurveyStatus } from '../../models/poe-survey-status.model';
import { RequestDetails } from '../../models/request-details.model';
import {
  SpecialInvestmentsM2PercentageData,
  SpecialInvestmentsM2PercentageMonthData
} from '../../models/special-investments-m2-percentage-data.model';
import { SpecialInvestmentsMilestoneInvoice } from '../../models/special-investments-milestone-invoice.model';
import { SpecialInvestmentsMilestonePayment } from '../../models/special-investments-milestone-payment.model';
import { SpecialInvestmentsMilestone2Details } from '../../models/special-investments-milestone2-details.model';
import { TaskOwner } from '../../models/task-owner.model';
import { UpdateCustomerAckDocument } from '../../models/update-customer-ack-document.model';
import { UpdatePayee } from '../../models/update-payee.model';
import { UsageModel } from '../../models/usage.model';
import { SettingsService } from '../common/settings.service';
import { AddEngagementDetails } from '../../models/add-engagement-details.model';

@Injectable({
  providedIn: 'root'
})
export class OsmosisEditService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  getFactDataByRequestDetailsById(
    requestDetailId: number
  ): Observable<RequestDetails> {
    return this.http.get<RequestDetails>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetFactDataByRequestDetailId/RequestDetailId/' +
        requestDetailId
    );
  }

  getPartnerTypeDropDown(): Observable<PartnerType[]> {
    return this.http.get<PartnerType[]>(
      this.settings.baseUrl + 'api/PartnerType/GetAll'
    );
  }

  ChangeEngagementTypeDropdown(
    engId: number,
    AN: string
  ): Observable<EngagementTypeDropdown[]> {
    return this.http.get<EngagementTypeDropdown[]>(
      this.settings.baseUrl +
        'api/EngagementDetails/ChangeEngagementTypeDropdown/engId/' +
        engId +
        '/AN/' +
        AN
    );
  }

  addPartner(partnerModel: PartnerModel) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PartnerInput/AddPartnerInput',
      partnerModel,
      { headers }
    );
  }

  addCsiPartner(partnerModel: PartnerModel) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl + 'api/PartnerDetails/AddPartnerInput',
      partnerModel,
      { headers }
    );
  }

  addCustomer(customerModel: CustomerModel) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/CustomerInput/AddCustomerInput',
      customerModel,
      { headers }
    );
  }
  submitChangeEngagementType(engModel: AddEngagementType) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/EngagementDetails/SubmitChangeEngagementType',
      engModel,
      { headers }
    );
  }
  getCustomerAcknowledgementFile(
    engId: number
  ): Observable<CustomerAcknowledgement[]> {
    return this.http.get<CustomerAcknowledgement[]>(
      this.settings.baseUrl +
        'api/EngagementDetails/ListofCustomerAckCsvFiles/' +
        engId
    );
  }
  getEngagementSurveys(engId: number) {
    return this.http.get<EngagementSurvey[]>(
      this.settings.baseUrl + 'api/PoeInformation/GetEngagementSurveys/' + engId
    );
  }
  getSurveyResponseFile(
    engId: number,
    surTyp: string
  ): Observable<CustomerAcknowledgement[]> {
    return this.http.get<CustomerAcknowledgement[]>(
      this.settings.baseUrl +
        'api/PoeInformation/ListofSurveyCsvFiles/' +
        engId +
        '/' +
        surTyp
    );
  }

  deleteCustomerAcknowledgementFile(engId: number, fileName: string) {
    return this.http.get(
      this.settings.baseUrl +
        'api/EngagementDetails/DeleteFile/' +
        engId +
        '/' +
        fileName
    );
  }

  addPoeInformation(poeInformation: PoeInformation) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PoeInformation/AddPoeInformation_V2',
      poeInformation,
      { headers }
    );
  }

  addPoeInformationSurvey(poeInformationSurvey: PoeInformationSurvey) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PoeInformation/AddPoeInformationSurvey',
      poeInformationSurvey,
      { headers }
    );
  }

  updatePOEInformation(poeInformationSurvey: UpdatePOEInformationRequest) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PoeInformation/UpdatePOEInformation',
      poeInformationSurvey,
      { headers }
    );
  }

  updateDealAssociationPOEInformation(
    advisorIncentivePOEInformation: UpdateAdvisorIncentivesPOEInformationRequest
  ) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/PoeInformation/UpdateDealAssociationPOEInformation',
      advisorIncentivePOEInformation,
      { headers }
    );
  }

  getPoeSurveyResponse(
    engId: string,
    surTyp: string,
    surNam: string
  ): Observable<NominationPOESurvey> {
    return this.http.get<NominationPOESurvey>(
      this.settings.baseUrl +
        'api/PoeInformation/GetSurveyResponse/' +
        engId +
        '/' +
        surTyp +
        '/' +
        surNam
    );
  }

  getEngagementTypeDropDown(): Observable<EngagementType[]> {
    return this.http.get<EngagementType[]>(
      this.settings.baseUrl + 'api/EngagementType/GetAll'
    );
  }

  getPrivateEngagementTypeDropDown(
    programTypeID: number
  ): Observable<EngagementType[]> {
    return this.http.get<EngagementType[]>(
      this.settings.baseUrl +
        'api/EngagementType/GetPrivateEngagementTypes/' +
        programTypeID
    );
  }

  getPoeStatusDropDown(): Observable<PoeStatus[]> {
    return this.http.get<PoeStatus[]>(
      this.settings.baseUrl + 'api/PoeStatus/GetAll'
    );
  }
  getODimIncentiveDropDown(): Observable<ODimIncentive[]> {
    return this.http.get<ODimIncentive[]>(
      this.settings.baseUrl + 'api/EngagementDetails/GetAllIncentive'
    );
  }

  addEngagementDetails(engagementDetails: AddEngagementDetails) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/EngagementDetails/AddEngagementDetail',
      engagementDetails,
      { headers }
    );
  }
  addEngagementExtension(engagementExtension: EngagementExtensionDetails) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/EngagementDetails/AddExtensionDetail',
      engagementExtension,
      { headers }
    );
  }

  getEngagementExtension(engId: number) {
    return this.http.get<EngagementExtensionDetails>(
      this.settings.baseUrl +
        'api/EngagementDetails/GetExtensionDetailByEngagementId/' +
        engId
    );
  }
  submitCustomerAck(uodateCustomerAck: UpdateCustomerAckDocument) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/EngagementDetails/UpdateCustomerAckDocument',
      uodateCustomerAck,
      { headers }
    );
  }

  addUsageDetails(usageModel: UsageModel) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/Usage/AddUsage',
      usageModel,
      { headers }
    );
  }

  getTaskOwnerDropDown(): Observable<TaskOwner[]> {
    return this.http.get<TaskOwner[]>(
      this.settings.baseUrl + 'api/TaskOwner/GetAll'
    );
  }

  getPmoStatusDropDown(): Observable<PmoStatus[]> {
    return this.http.get<PmoStatus[]>(
      this.settings.baseUrl + 'api/PmoStatus/GetAll'
    );
  }

  getPMONextStepsDropDown(): Observable<PmoNextStatus[]> {
    return this.http.get<PmoNextStatus[]>(
      this.settings.baseUrl + 'api/PmonextStep/GetAll'
    );
  }

  getL1InternalStatusDropDown(): Observable<L1InternalStatus[]> {
    return this.http.get<L1InternalStatus[]>(
      this.settings.baseUrl + 'api/L1internalStatus/GetAll'
    );
  }

  getL2InternalStatusDropDown(): Observable<L2InternalStatus[]> {
    return this.http.get<L2InternalStatus[]>(
      this.settings.baseUrl + 'api/L2InternalStatus/GetAll'
    );
  }

  getDeclineReasonDropDown(): Observable<DeclineReason[]> {
    return this.http.get<DeclineReason[]>(
      this.settings.baseUrl + 'api/DeclineReason/GetAll'
    );
  }

  getExpectedPaymentMonthDropDown(): Observable<MonthList[]> {
    return this.http.get<MonthList[]>(
      this.settings.baseUrl + 'api/ODimMonthList/GetAll'
    );
  }

  getConfidenceDropDown(): Observable<Confidence[]> {
    return this.http.get<Confidence[]>(
      this.settings.baseUrl + 'api/ODimConfidence/GetAll'
    );
  }

  getSpecialInvestmentMilestonePayment(
    engagementId: string
  ): Observable<SpecialInvestmentsMilestonePayment[]> {
    return this.http.get<SpecialInvestmentsMilestonePayment[]>(
      this.settings.baseUrl +
        'api/SpecialInvestments/GetMilestonePayments/' +
        engagementId
    );
  }

  getMilestone2PaymentStatusDropdown(): Observable<Milestone2PaymentStatus[]> {
    return this.http.get<Milestone2PaymentStatus[]>(
      this.settings.baseUrl +
        'api/SpecialInvestments/Milestone2PaymentStatus/GetAll'
    );
  }

  getMilestone2DesignationDropdown(): Observable<Milestone2Designation[]> {
    return this.http.get<Milestone2Designation[]>(
      this.settings.baseUrl +
        'api/SpecialInvestments/Milestone2Designations/GetAll'
    );
  }

  updateSpecialInvestmentMilestone2InvoiceDetails(
    milestone2Invoice: SpecialInvestmentsMilestoneInvoice
  ) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/SpecialInvestments/SaveMilestonePaymentsInvoice',
      milestone2Invoice,
      { headers }
    );
  }

  getSpecialInvestmentMilestone2Details(
    engagementId: string
  ): Observable<SpecialInvestmentsMilestone2Details> {
    return this.http.get<SpecialInvestmentsMilestone2Details>(
      this.settings.baseUrl +
        'api/SpecialInvestments/GetMilestone2Details/' +
        engagementId
    );
  }

  updateSpecialInvestmentMilestone2Details(
    milestone2Details: SpecialInvestmentsMilestone2Details
  ) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/SpecialInvestments/SaveMilestone2Details',
      milestone2Details,
      { headers }
    );
  }

  getPoeSurveyStatusDropDown(): Observable<PoeSurveyStatus[]> {
    return this.http.get<PoeSurveyStatus[]>(
      this.settings.baseUrl + 'api/ODimPoeSurveyStatus/GetAll'
    );
  }

  getPoeDocStatusDropDown(): Observable<PoeDocStatus[]> {
    return this.http.get<PoeDocStatus[]>(
      this.settings.baseUrl + 'api/ODimPoeDocStatus/GetAll'
    );
  }
  getPoeInvoiceStatusDropDown(): Observable<PoeinvoiceStatus[]> {
    return this.http.get<PoeinvoiceStatus[]>(
      this.settings.baseUrl + 'api/PoeInformation/GetAll'
    );
  }

  addNotes(notesModel: NotesModel) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/Notes/AddNotes',
      notesModel,
      { headers }
    );
  }

  getNotes(reqId: number): Observable<NotesModel[]> {
    return this.http.get<NotesModel[]>(
      this.settings.baseUrl + 'api/Notes/GetAllNotesById/rId/' + reqId
    );
  }

  addPmoInternal(pmoInternalModel: PmoInternalModel) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PmoInternal/AddPmoInternalInput',
      pmoInternalModel,
      { headers }
    );
  }

  getUploadedPOEDocs_ByEngagementId(
    requestDetailId: number
  ): Observable<PoeDocHyperLink[]> {
    return this.http.get<PoeDocHyperLink[]>(
      this.settings.baseUrl +
        'api/PoeInformation/GetUploadedPOEDocs_ByEngagementId/RequestDetailId/' +
        requestDetailId
    );
  }

  getUploadedAdditionalDocs_ByEngagementId(
    requestDetailId: number
  ): Observable<AdditionalDocHyperLink[]> {
    return this.http.get<AdditionalDocHyperLink[]>(
      this.settings.baseUrl +
        'api/PoeInformation/GetUploadedAdditionalDocs_ByEngagementId/RequestDetailId/' +
        requestDetailId
    );
  }

  updateCustomerAcknowledgementReviewStatus(request: DocumentReviewModel) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/EngagementDetails/UpdateCustomerAcknowledgementReviewStatus',
      request
    );
  }

  getInvoiceRejectionReasonDropDown(
    documentType: DocumentsType
  ): Observable<InvoiceRejectReason[]> {
    return this.http.get<InvoiceRejectReason[]>(
      this.settings.baseUrl +
        `api/DocumentDeclineReason/GetAll?documentType=${documentType}`
    );
  }
  updatePOEDocumentReviewStatus(request: DocumentReviewModel) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/PoeInformation/UpdatePOEDocumentsReviewStatus',
      request
    );
  }

  updatePOEDocumentReviewStatusV2(
    request: DocumentReviewModel,
    documentId: number
  ) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        `api/PoeInformation/UpdatePOEDocumentsReviewStatusV2/?documentId=${documentId}`,
      request
    );
  }

  updatePOESurveyReviewStatus(request: DocumentReviewModel) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PoeInformation/UpdatePOESurveyReviewStatus',
      request
    );
  }

  updatePayeeInformation(request: UpdatePayee) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PartnerType/UpdatePayeeInfo',
      request
    );
  }

  updatePOEDocumentType(request: DocumentDetailsModel) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PoeInformation/UpdatePOEDocumentType',
      request
    );
  }

  updateDealAssociationDocumentsReviewStatus(
    request: DocumentReviewModel,
    documentId: number
  ) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        `api/PoeInformation/UpdateDealAssociationDocumentsReviewStatus/?documentId=${documentId}`,
      request
    );
  }

  getPOEDocumentsForEngagementDetail(engId: number) {
    return this.http.get<PoeNominationDocuments>(
      this.settings.baseUrl +
        'api/PoeInformation/GetPOEDocumentsForEngagementDetail/RequestDetailId/' +
        engId
    );
  }

  getPOEDocumentHistory(
    requestDetailId: number
  ): Observable<PoeDocHyperLink[]> {
    return this.http.get<PoeDocHyperLink[]>(
      this.settings.baseUrl +
        'api/PoeInformation/GetPOEDocumentHistory/RequestDetailId/' +
        requestDetailId
    );
  }

  uploadPOEDocToBlob(
    request: CustomerAcknowledgement,
    requestDetailId: number
  ) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/EngagementDetails/UploadPOEDocToAzureBlob/' +
        requestDetailId,
      request
    );
  }

  submitUploadedPOEDocuments(request: PoeDocument) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/PoeInformation/UploadPOEDocuments',
      request
    );
  }

  submitSpecialInvestmentUploadedPOEDocuments(
    request: SpecialInvestmentPoeDocument
  ) {
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/PoeInformation/UpdateSpecialInvestmentDocument',
      request
    );
  }

  getIncentiveDataByRequestDetailsById(
    incentiveId: number
  ): Observable<IncentiveDetails> {
    return this.http.get<IncentiveDetails>(
      this.settings.baseUrl +
        'api/M365acceleratorNominations/GetIncentiveDataByRequestDetailsId/IncentiveId/' +
        incentiveId
    );
  }

  addIncentiveDetails(engagementDetails: EngagementDetails) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl + 'api/IncentiveDetails/AddIncentiveDetail',
      engagementDetails,
      { headers }
    );
  }

  getIncentivePaymentM2DetailsById(
    incentiveId: number
  ): Observable<MsaipMilestonePayment[]> {
    return this.http.get<MsaipMilestonePayment[]>(
      this.settings.baseUrl +
        'api/MsaipMilestone2/GetMsaipMilestonePayments/' +
        incentiveId
    );
  }

  getMsaipActionsDropDown(): Observable<MsaipAction[]> {
    return this.http.get<MsaipAction[]>(
      this.settings.baseUrl + 'api/MsaiDetails/MsaipAction/GetAll'
    );
  }

  getmsaipExceptionDisputeStatusDropDown(): Observable<
    MsaipExceptionDisputeStatus[]
  > {
    return this.http.get<MsaipExceptionDisputeStatus[]>(
      this.settings.baseUrl +
        'api/MsaiDetails/MsaipExceptionDisputeStatus/GetAll'
    );
  }

  getMsaipRequestReasonDropDown(): Observable<MsaipRequestReason[]> {
    return this.http.get<MsaipRequestReason[]>(
      this.settings.baseUrl + 'api/MsaiDetails/MsaipRequestReason/GetAll'
    );
  }

  updateMsaipM2InvoiceDetails(msaipMilestonePayment: MsaipMilestonePayment) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseUrl +
        'api/MsaipMilestone2/UpdateMilestonePaymentsInvoice',
      msaipMilestonePayment,
      { headers }
    );
  }

  getL2InternalStatusForSiDropDown(): Observable<L2InternalStatus[]> {
    return this.http.get<L2InternalStatus[]>(
      this.settings.baseUrl + 'api/L2InternalStatus/GetAllL2StatusForSI'
    );
  }

  getL1InternalStatusForSiDropDown(): Observable<L1InternalStatus[]> {
    return this.http.get<L1InternalStatus[]>(
      this.settings.baseUrl + 'api/L1internalStatus/GetAllL1StatusForSI'
    );
  }

  getPMONextStepsForSiDropDown(): Observable<PmoNextStatus[]> {
    return this.http.get<PmoNextStatus[]>(
      this.settings.baseUrl + 'api/PmonextStep/GetAllPMONextStepsForSI'
    );
  }

  getMilestonePaymentStatus(): Observable<MilestonePaymentStatus[]> {
    return this.http.get<MilestonePaymentStatus[]>(
      this.settings.baseUrl +
        'api/L1internalStatus/GetAllMilestonePaymentStatus'
    );
  }

  getSpecialInvestmentsM2PercentageData(
    engagementId: number
  ): Observable<SpecialInvestmentsM2PercentageData[]> {
    return this.http.get<SpecialInvestmentsM2PercentageData[]>(
      this.settings.baseEventsUrl +
        'api/CSIM2EngagementDetails/GetM2PaymentDetails/' +
        engagementId
    );
  }

  UpdateM2PaymentInvoiceDetail(
    m2PercentagePaymentInvoiceRequest: SpecialInvestmentsM2PercentageMonthData
  ) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post<ApiResponse>(
      this.settings.baseEventsUrl +
        'api/CSIM2EngagementDetails/UpdateM2PaymentInvoiceDetail',
      m2PercentagePaymentInvoiceRequest,
      { headers }
    );
  }

  getCsiMilestone2PaymentStatusDropdown(): Observable<
    Milestone2PaymentStatus[]
  > {
    return this.http.get<Milestone2PaymentStatus[]>(
      this.settings.baseEventsUrl +
        'api/CSIM2EngagementDetails/GetMilestone2PaymentStatuses'
    );
  }
}
